import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Card, Overline, Pill, ProgressBar, Icon, PageLoader } from "../../components/ui-kit";

const tone = (m) => m >= 75 ? "green" : m >= 55 ? "yellow" : "coral";
const color = (m) => m >= 75 ? "#20B982" : m >= 55 ? "#F3B83F" : "#EF6B6B";

export default function StudentsPage() {
  const [students, setStudents] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/teacher/students").then(({ data }) => setStudents(data)); }, []);
  if (!students) return <PageLoader />;
  const filtered = students.filter((s) => s.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
        <div><Overline>Class 10</Overline><h1 className="text-2xl font-bold text-mim-navy mt-1">Students</h1></div>
        <div className="relative">
          <Icon name="Search" className="w-4 h-4 text-mim-muted absolute left-3 top-1/2 -translate-y-1/2" />
          <input data-testid="student-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search students…"
            className="pl-9 pr-4 py-2.5 rounded-xl border border-mim-line text-sm outline-none focus:border-mim-blue w-56" />
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {filtered.map((s) => (
          <Link key={s.id} to={`/teacher/student/${s.id}`}>
            <Card hover className="flex items-center gap-3 animate-fade-up">
              <div className="w-11 h-11 rounded-full bg-mim-soft text-mim-blue flex items-center justify-center font-bold">{s.name.split(" ").map(n=>n[0]).join("")}</div>
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-mim-navy truncate">{s.name}</h4>
                <div className="mt-1.5"><ProgressBar value={s.mastery} color={color(s.mastery)} height="h-1.5" /></div>
              </div>
              <Pill tone={tone(s.mastery)}>{s.mastery}%</Pill>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
